import React from 'react';
import Seo from '../../components/Seo';
import LegalPageLayout from './LegalPageLayout';

export default function PrivacyPolicy() {
  return (
    <LegalPageLayout title="Privacy Policy" lastUpdated="10 June 2026">
      <Seo
        title="Privacy Policy"
        description="How Atlas Academy collects, uses, and protects your personal data in accordance with UK GDPR and the Data Protection Act 2018."
        path="/privacy-policy"
      />
      <div>
        <h2>1. Who we are</h2>
        <p>
          Atlas Academy ("we", "us", "our") provides online distance learning courses. We are the data
          controller for personal information collected through this website. You can contact us at{' '}
          <a href="mailto:info@atlas-academy.co.uk">info@atlas-academy.co.uk</a> or by post at Green Building,
          Unit 1, Block M 46, Orchard Place, London E14 0JW, United Kingdom.
        </p>
      </div>
      <div>
        <h2>2. What information we collect</h2>
        <ul>
          <li><strong>Identity and contact data</strong> — name, email address, phone number, and postal address, provided when you enquire, apply, or enrol.</li>
          <li><strong>Application data</strong> — details you submit on our application form, such as prior qualifications and your chosen course.</li>
          <li><strong>Payment data</strong> — payments are processed securely by Stripe. We do not store your full card details on our systems.</li>
          <li><strong>Usage data</strong> — information about how you use our website, collected through analytics cookies only if you consent (see our <a href="/cookie-policy">Cookie Policy</a>).</li>
        </ul>
      </div>
      <div>
        <h2>3. How we use your information</h2>
        <ul>
          <li>To respond to enquiries and process course applications and enrolments (performance of a contract).</li>
          <li>To take payments and manage payment plans (performance of a contract).</li>
          <li>To send you service messages about your course or application (legitimate interests).</li>
          <li>To send marketing emails such as course updates and offers, only where you have opted in; you may unsubscribe at any time (consent).</li>
          <li>To understand how our website is used and improve it, where you accept analytics cookies (consent).</li>
        </ul>
      </div>
      <div>
        <h2>4. Who we share data with</h2>
        <p>
          We share personal data only with service providers who help us operate: our hosting providers,
          our database provider, Stripe (payment processing), our email delivery provider, and the awarding
          bodies (such as OTHM or QUALIFI) where required to register you for a qualification. We do not sell
          your personal data.
        </p>
      </div>
      <div>
        <h2>5. How long we keep your data</h2>
        <p>
          Enquiry records are kept for up to 24 months. Enrolment and qualification records are kept for as
          long as required to administer your qualification and meet our legal and awarding-body obligations.
        </p>
      </div>
      <div>
        <h2>6. Your rights</h2>
        <p>
          Under UK GDPR you have the right to access, correct, or delete your personal data, to object to or
          restrict processing, to data portability, and to withdraw consent at any time. To exercise any of
          these rights, email <a href="mailto:info@atlas-academy.co.uk">info@atlas-academy.co.uk</a>. You also
          have the right to complain to the Information Commissioner's Office (ICO) at{' '}
          <a href="https://ico.org.uk" target="_blank" rel="noopener noreferrer">ico.org.uk</a>.
        </p>
      </div>
      <div>
        <h2>7. Security</h2>
        <p>
          We use appropriate technical and organisational measures to protect your data, including encrypted
          connections (HTTPS), access controls, and reputable infrastructure providers.
        </p>
      </div>
      <div>
        <h2>8. Changes to this policy</h2>
        <p>
          We may update this policy from time to time. The latest version will always be available on this
          page, with the "last updated" date shown above.
        </p>
      </div>
    </LegalPageLayout>
  );
}
